// ========================================
// components/admin/AdminSecurity.js - Admin 2FA Management
// ========================================

import React, { useState, useEffect } from 'react';
import axios from '../../utils/axiosConfig';

const AdminSecurity = () => {
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const [verifyCode, setVerifyCode] = useState('');
  const [disableCode, setDisableCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showSetup, setShowSetup] = useState(false);

  // Fetch current 2FA status
 useEffect(() => {
  const fetchStatus = async () => {
    try {
      const adminToken = localStorage.getItem('adminToken');
      const response = await axios.get('/api/admin/2fa/status', {
        headers: { Authorization: `Bearer ${adminToken}` }
      });
      setTwoFactorEnabled(response.data.enabled);
    } catch (err) {
      console.error(err);
    }
  };
  fetchStatus();
}, []);

  const handleSetup = async () => {
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const adminToken = localStorage.getItem('adminToken');
      const response = await axios.post('/api/admin/2fa/setup', {}, {
        headers: { Authorization: `Bearer ${adminToken}` }
      });
      setQrCode(response.data.qrCode);
      setSecret(response.data.secret);
      setShowSetup(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to setup 2FA');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyEnable = async () => {
    if (!verifyCode) {
      setError('Please enter the 6-digit code');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const adminToken = localStorage.getItem('adminToken');
      await axios.post('/api/admin/2fa/verify-enable', { token: verifyCode }, {
        headers: { Authorization: `Bearer ${adminToken}` }
      });
      setTwoFactorEnabled(true);
      setShowSetup(false);
      setMessage('2FA has been enabled successfully!');
      setVerifyCode('');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid code');
    } finally {
      setLoading(false);
    }
  };

  const handleDisable = async () => {
    if (!disableCode) {
      setError('Please enter your current 2FA code to disable');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const adminToken = localStorage.getItem('adminToken');
      await axios.post('/api/admin/2fa/disable', { token: disableCode }, {
        headers: { Authorization: `Bearer ${adminToken}` }
      });
      setTwoFactorEnabled(false);
      setMessage('2FA has been disabled.');
      setDisableCode('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to disable 2FA');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-card">
      <h3 className="admin-card-title">Two-Factor Authentication (2FA)</h3>
      {message && <div className="success-message" style={{ background: '#d1fae5', color: '#065f46', padding: '10px', borderRadius: '8px', marginBottom: '15px' }}>{message}</div>}
      {error && <div className="error-message" style={{ marginBottom: '15px' }}>{error}</div>}
      
      {!twoFactorEnabled ? (
        <div>
          <p>Add an extra layer of security to your admin account.</p>
          {!showSetup ? (
            <button onClick={handleSetup} className="admin-export-btn all" disabled={loading}>
              {loading ? 'Setting up...' : 'Enable 2FA'}
            </button>
          ) : (
            <div>
              <p>Scan the QR code below with Google Authenticator or Authy:</p>
              {qrCode && <img src={qrCode} alt="QR Code" style={{ margin: '15px 0', maxWidth: '200px' }} />}
              <p style={{ fontSize: '12px', wordBreak: 'break-all' }}>Secret key (if cannot scan): <code>{secret}</code></p>
              <div className="form-group">
                <label>Enter 6-digit code from app</label>
                <input
                  type="text"
                  maxLength="6"
                  className="form-input"
                  value={verifyCode}
                  onChange={(e) => setVerifyCode(e.target.value)}
                  placeholder="123456"
                />
              </div>
              <button onClick={handleVerifyEnable} className="admin-export-btn all" disabled={loading}>
                {loading ? 'Verifying...' : 'Verify and Enable'}
              </button>
              <button onClick={() => setShowSetup(false)} style={{ marginLeft: '10px' }} className="modal-cancel-btn">Cancel</button>
            </div>
          )}
        </div>
      ) : (
        <div>
          <p>2FA is currently <strong style={{ color: '#2E7D32' }}>ENABLED</strong>. Your account is protected.</p>
          <div className="form-group" style={{ maxWidth: '300px' }}>
            <label>Enter your current 2FA code to disable:</label>
            <input
              type="text"
              maxLength="6"
              className="form-input"
              value={disableCode}
              onChange={(e) => setDisableCode(e.target.value)}
              placeholder="123456"
            />
          </div>
          <button onClick={handleDisable} className="admin-export-btn newsletter" disabled={loading}>
            {loading ? 'Disabling...' : 'Disable 2FA'}
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminSecurity;